import { MapContainer, TileLayer, GeoJSON, useMap } from "react-leaflet";

import axios from "axios";

import { useState, useEffect } from "react";

import "leaflet/dist/leaflet.css";

import "leaflet-defaulticon-compatibility";

import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css";

import L from "leaflet";

import MarkerClusterGroup from "react-leaflet-markercluster";

import "leaflet.markercluster/dist/MarkerCluster.Default.css";

import "leaflet.markercluster/dist/MarkerCluster.css";

import "./App.css";

import * as turf from "@turf/turf";

 
 
// --------------------------------------------------

// LISTEN FOR ROLE ID SENT FROM MEDADASHBOARD

// --------------------------------------------------

window.addEventListener("message", function (event) {

  if (event.origin !== "https://medadashboard.idaminfra.com") return;
 
  if (event.data.type === "SET_ROLE_ID") {

    window.parentUserId = event.data.roleId;   // store globally

    console.log("React received role ID:", window.parentUserId);

  }

});
 
 
// --------------------------------------------------

// MAP FIT TO MAHARASHTRA

// --------------------------------------------------

function FitBoundsToMaharashtra({ data }) {

  const map = useMap();
 
  useEffect(() => {

    if (data) {

      const layer = L.geoJSON(data);

      map.fitBounds(layer.getBounds());

    }

  }, [data]);
 
  return null;

}
 
 
// Utility to randomize polygon color

function getRandomHex() {

  return "#" + Math.floor(Math.random() * 16777215).toString(16);

}
 
 
// --------------------------------------------------

// MAIN APP COMPONENT

// --------------------------------------------------

function App() {

  const [geoData, setGeoData] = useState(null);

  const [mahaBorder, setMahaBorder] = useState(null);

  const [districts, setDistricts] = useState(null);

  const [layerKey, setLayerKey] = useState(0);
 
  // const [userId, setUserId] = useState(window.parentUserId || null); // <- Role ID from parent
  const [userId, setUserId] = useState(
  window.parentUserId ? Number(window.parentUserId) : null
);
  // const API_BASE = `${window.location.origin}/api`;

  const API_BASE = `${window.location.origin}/api`;
  // const API_BASE = " http://10.229.214.90:5005";

 
  const [mahaPolygon, setMahaPolygon] = useState(null);

  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [isThemeLoading, setIsThemeLoading] = useState(false);
  const [selectedThemes, setSelectedThemes] = useState([]); // array of csv names
  const [geoLayers, setGeoLayers] = useState({}); // { themeName: geojson }
  const EXCLUDED_FROM_SELECT_ALL = ["PM-Kusum Project.csv"];
  const formatSchemeName = (file) =>
  file.replace(".csv", "").replace(/_/g, " ");



 
  // --------------------------------------------------

  const schemeClusterColors = {
  "Solar Project.csv": "#fbc02d",   // yellow
  "Wind project.csv": "#6489ad",    // blue
   "Small Hydro Power Project.csv": "#0288d1",   // cyan
  "Waste to Energy.csv": "#be6142", // brown
  "Cogeneration Project.csv": "#2e7d32", // green
  "Government Building Solarization.csv": "#f57c00",
  "PM-Kusum Project.csv": "#7cb342",
  "Windy Sites Maharashtra.csv": "#455a64",
  "Mahaurja Offices.csv": "#5d4037",
  "Green Hydrogen Project.csv": "#00897b"
};

const createClusterIcon = (theme) => (cluster) => {
  const count = cluster.getChildCount();
  const color = schemeClusterColors[theme] || "#9e9e9e";

  return L.divIcon({
    html: `
      <div style="
        background:${color};
        width:40px;
        height:40px;
        border-radius:50%;
        display:flex;
        align-items:center;
        justify-content:center;
        color:#fff;
        font-weight:600;
+       border: 10px solid #000;
        box-shadow:0 0 6px rgba(0,0,0,0.4);
      ">
        ${count}
      </div>
    `,
    className: "",
    iconSize: [40, 40]
  });
};

const handleResetThemes = async () => {
  setIsThemeLoading(true); // 🔥 start loader

  try {
    setGeoLayers({});
    setSelectedThemes([]);

    if (uploadedFiles.includes(DEFAULT_THEME)) {
      const geojsonFilename = DEFAULT_THEME.replace(".csv", ".geojson");

      const response = await axios.get(
        `${API_BASE}/geojson/${geojsonFilename}`
      );

      const filtered = filterPointsInsideMaharashtra(response.data);

      setGeoLayers({
        [DEFAULT_THEME]: filtered
      });

      setSelectedThemes([DEFAULT_THEME]);
    }

  } catch (err) {
    console.error(err);
    alert("Failed to reset themes.");
  } finally {
    setIsThemeLoading(false);
  }
};



  // WAIT UNTIL postMessage PROVIDES roleId

  // --------------------------------------------------

const departmentIcons = {
  "Solar Project.csv": "/images/solar_energy.png",
  "Wind project.csv": "/images/wind.png",
  "Small Hydro Power Project.csv": "/images/shp.png",
  "Waste to Energy.csv": "/images/waste_to_energy.png",
  "Cogeneration Project.csv": "/images/cogeneration.png",
  "Government Building Solarization.csv": "/images/solar_buildings.png",
  "PM-Kusum Project.csv": "/images/kusum.png",
  "Windy Sites Maharashtra.csv": "/images/windy_sites.png",
  "Mahaurja Offices.csv": "/images/government.png",
  "Green Hydrogen Project.csv": "/images/green_hydrogen.png"
};

const getCustomIcon = (themeName) => {
  const iconUrl = departmentIcons[themeName] || "/images/default.png";

  return L.icon({
    iconUrl,
    iconSize: [32, 32],       // size of PNG
    iconAnchor: [16, 32],     // tip of pin
    popupAnchor: [0, -28],    // popup position
  });
};

const handleToggleAllThemes = async () => {
  const selectableThemes = uploadedFiles.filter(
    file => !EXCLUDED_FROM_SELECT_ALL.includes(file)
  );

  setIsThemeLoading(true); // 🔥 ALWAYS start loader

  // ---------- UNSELECT ALL ----------
  if (selectedThemes.length === selectableThemes.length) {
    setSelectedThemes([]);
    setGeoLayers({});

    setTimeout(() => {
      setIsThemeLoading(false);
    }, 300);

    return;
  }

  // ---------- SELECT ALL ----------
  try {
    const newLayers = {};
    const newSelected = [];

    for (const csvFilename of selectableThemes) {
      const geojsonFilename = csvFilename.replace(".csv", ".geojson");
      const response = await axios.get(
        `${API_BASE}/geojson/${geojsonFilename}`
      );

      const filtered = filterPointsInsideMaharashtra(response.data);

      newLayers[csvFilename] = filtered;
      newSelected.push(csvFilename);
    }

    setGeoLayers(newLayers);
    setSelectedThemes(newSelected);

  } catch (err) {
    console.error(err);
    alert("Failed to load all themes.");
  } finally {
    setIsThemeLoading(false);
  }
};



useEffect(() => {
  const handler = (event) => {
    if (event.origin !== "https://medadashboard.idaminfra.com") return;

    if (event.data.type === "SET_ROLE_ID") {
      const roleId = Number(event.data.roleId);

      window.parentUserId = roleId; // persist
      setUserId(roleId);            // 🔥 THIS WAS MISSING
      console.log("React received role ID:", roleId);
    }
  };

  window.addEventListener("message", handler);

  return () => window.removeEventListener("message", handler);
}, []);

 
 
  // --------------------------------------------------

  // USER UPLOAD PERMISSION CONTROL

  // --------------------------------------------------

  const allowedUsers = [2, 3, 4, 5, 6, 7, 8, 9, 10,11];

  const canUpload = userId !== null && allowedUsers.includes(Number(userId));

 
 
  // --------------------------------------------------

  // LOAD MAHARASHTRA BORDER

  // --------------------------------------------------

useEffect(() => {
  fetch("/maharashtra.geojson")
    .then((res) => res.json())
    .then((data) => {
      setMahaBorder(data);

      let merged = data.features[0];

      for (let i = 1; i < data.features.length; i++) {
        merged = turf.union(merged, data.features[i]);
      }

      setMahaPolygon(merged);
    })
    .catch((err) => console.error("Maharashtra GeoJSON error:", err));
}, []);


 
 
  // --------------------------------------------------

  // FILE UPLOAD HANDLER

  // --------------------------------------------------

  const filterPointsInsideMaharashtra = (geojson) => {
  if (!mahaPolygon || !geojson || !geojson.features) return geojson;

  const filteredFeatures = geojson.features.filter((feature) => {
    if (!feature.geometry || feature.geometry.type !== "Point") return false;

    const point = turf.point(feature.geometry.coordinates);
    return turf.booleanPointInPolygon(point, mahaPolygon);
  });

  return {
    type: "FeatureCollection",
    features: filteredFeatures
  };
};

const handleFileSelect = (event) => {
  const file = event.target.files[0];
  if (file) {
    setSelectedFile(file);
  }
};

const handleSubmitUpload = async () => {
  if (!userId) {
    alert("Role ID not received yet.");
    return;
  }

  if (!selectedFile) {
    alert("Please select a file first.");
    return;
  }

  const formData = new FormData();
  formData.append("file", selectedFile);
  formData.append("user_id", userId);

  try {
    setIsUploading(true);

const res = await axios.post(`${API_BASE}/upload-csv`, formData);
const geojsonUrl = API_BASE + res.data.geojson_url;

const geojsonData = await axios.get(geojsonUrl);

const filtered = filterPointsInsideMaharashtra(geojsonData.data);
setGeoData(filtered);
setLayerKey((prev) => prev + 1);

setSelectedFile(null); // reset after success

// ✅ SUCCESS ALERT
alert("CSV file has been uploaded successfully.\nRefresh the map to see it.");


  } catch (err) {
    console.error(err);

    if (err.response && err.response.data) {
      const data = err.response.data;

      if (data.errors && Array.isArray(data.errors)) {
        const errorMessage =
          `${data.message}\n\n` +
          data.errors
            .slice(0, 5)
            .map(e => `Row ${e.row}: ${e.error}`)
            .join("\n");

        alert(errorMessage);

      } else if (data.error) {
        alert(data.error);
      } else {
        alert("Upload failed due to invalid data.");
      }

    } else {
      alert("Upload failed. Please try again.");
    }

    setSelectedFile(null); // reset after failure

  } finally {
    setIsUploading(false);
  }
};


 
 
  // --------------------------------------------------

  // LOAD EXISTING THEMES

  // --------------------------------------------------

  const [uploadedFiles, setUploadedFiles] = useState([]);

  const DEFAULT_THEME = "Cogeneration Project.csv";
  const [selectedTheme, setSelectedTheme] = useState(DEFAULT_THEME);
 
useEffect(() => {
  if (!mahaPolygon) return;

  axios
    .get(`${API_BASE}/list-uploads`)
    .then(async (res) => {
      setUploadedFiles(res.data.files);

      // ✅ Auto-load Cogeneration Project by default
      if (res.data.files.includes(DEFAULT_THEME)) {
        const geojsonFilename = DEFAULT_THEME.replace(".csv", ".geojson");

        const response = await axios.get(
          `${API_BASE}/geojson/${geojsonFilename}`
        );

        const filtered = filterPointsInsideMaharashtra(response.data);

        setGeoLayers({
          [DEFAULT_THEME]: filtered
        });

        setSelectedThemes([DEFAULT_THEME]);
      }
    })
    .catch((err) => console.error("Error loading uploads:", err));
}, [mahaPolygon]);


 
 
  const handleThemeChange = async (event) => {
  const csvFilename = event.target.value;
  setSelectedTheme(csvFilename);

  if (!csvFilename) return;

  setIsThemeLoading(true);

  const geojsonFilename = csvFilename.replace(".csv", ".geojson");

  try {
    const response = await axios.get(`${API_BASE}/geojson/${geojsonFilename}`);

    const filtered = filterPointsInsideMaharashtra(response.data);
    setGeoData(filtered);
    setLayerKey((prev) => prev + 1);

  } catch (err) {
    console.error(err);
    alert("GeoJSON not found. Upload CSV file first.");
  } finally {
    setIsThemeLoading(false);
  }
};

const handleThemeToggle = async (csvFilename) => {
  const isSelected = selectedThemes.includes(csvFilename);

  setIsThemeLoading(true); // 🔥 ALWAYS start loader

  if (isSelected) {
    // ---------- REMOVE THEME ----------
    setSelectedThemes(prev =>
      prev.filter(t => t !== csvFilename)
    );

    setGeoLayers(prev => {
      const copy = { ...prev };
      delete copy[csvFilename];
      return copy;
    });

    // Give React one tick to re-render so loader is visible
    setTimeout(() => {
      setIsThemeLoading(false);
    }, 300);

  } else {
    // ---------- ADD THEME ----------
    try {
      const geojsonFilename = csvFilename.replace(".csv", ".geojson");
      const response = await axios.get(
        `${API_BASE}/geojson/${geojsonFilename}`
      );

      const filtered = filterPointsInsideMaharashtra(response.data);

      setSelectedThemes(prev => [...prev, csvFilename]);
      setGeoLayers(prev => ({
        ...prev,
        [csvFilename]: filtered
      }));

    } catch (err) {
      alert(`Failed to load ${csvFilename}`);
    } finally {
      setIsThemeLoading(false);
    }
  }
};



  // --------------------------------------------------

  // POPUP HANDLER

  // --------------------------------------------------

// --------------------------------------------------
// POPUP HANDLER (FIXED)
// --------------------------------------------------
// --------------------------------------------------
// POPUP HANDLER (FINAL – TABLE SAFE)
// --------------------------------------------------
// --------------------------------------------------
// POPUP HANDLER (FINAL – NO LETTER STACKING)
// --------------------------------------------------
const onEachFeature = (feature, layer, theme) => {


  let html = `
<div style="
  font-family: Arial, sans-serif;
  font-size: 13px;
  min-width: 360px;
  max-width: 420px;
  max-height: 280px;
  overflow-y: auto;
  overflow-x: hidden;
">
  <div style="
    font-weight: bold;
    font-size: 15px;
    margin-bottom: 6px;
  ">
    Details : <span style="color:#1976d2;">
      ${theme.replace(".csv", "").replace(/_/g, " ")}
    </span>
  </div>


  <table style="
    width: 100%;
    border-collapse: collapse;
    table-layout: auto;
  ">
`;

  for (let key in feature.properties) {
    const label = key.replace(/_/g, " ");
    const value = feature.properties[key] ?? "—";

    html += `
<tr>
  <td style="
    border: 1px solid #e0e0e0;
    padding: 6px;
    width: 40%;
    font-weight: 600;
    vertical-align: top;
    white-space: normal;
    word-break: normal;
    overflow-wrap: break-word;
    background: #f7f7f7;
  ">
    ${label}
  </td>

  <td style="
    border: 1px solid #e0e0e0;
    padding: 6px;
    width: 60%;
    vertical-align: top;
    white-space: normal;
    word-break: normal;
    overflow-wrap: break-word;
  ">
    ${value}
  </td>
</tr>`;
  }

  html += `
  </table>
</div>
`;

  layer.bindPopup(html, {
    maxWidth: 450,
    minWidth: 360,
    autoPan: true,
    closeButton: true
  });
};


 
 
  // --------------------------------------------------

  // LOAD DISTRICTS

  // --------------------------------------------------

  useEffect(() => {

    fetch("/maharashtra2.geojson")

      .then((res) => res.json())

      .then((data) => setDistricts(data));

  }, []);
 
 
  // --------------------------------------------------

  // RENDER APP UI

  // --------------------------------------------------

  return (
<div>
 
     <div className="theme-dropdown">
  <div style={{
    border: "1px solid #ccc",
    borderRadius: "5px",
    padding: "8px",
    maxHeight: "220px",
    overflowY: "auto",
    background: "#fafafa"
  }}>

    <div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "8px",
    paddingBottom: "6px",
    borderBottom: "1px solid #ddd"
  }}
>
  {/* SELECT ALL */}
  <label
    style={{
      display: "flex",
      alignItems: "center",
      gap: "6px",
      fontSize: "13px",
      fontWeight: "600",
      cursor: "pointer"
    }}
  >
    <input
      type="checkbox"
      checked={
        uploadedFiles.filter(
          file => !EXCLUDED_FROM_SELECT_ALL.includes(file)
        ).length > 0 &&
        selectedThemes.length ===
          uploadedFiles.filter(
            file => !EXCLUDED_FROM_SELECT_ALL.includes(file)
          ).length
      }
      onChange={handleToggleAllThemes}
      disabled={isThemeLoading}
    />
    Select All
  </label>

  {/* RESET */}
  <button
    onClick={handleResetThemes}
    disabled={isThemeLoading}
    style={{
      padding: "2px 8px",
      fontSize: "12px",
      borderRadius: "4px",
      border: "1px solid #999",
      background: "#f5f5f5",
      cursor: isThemeLoading ? "not-allowed" : "pointer"
    }}
  >
    Reset
  </button>
</div>


  

    {/* INDIVIDUAL THEMES */}
    {uploadedFiles.length > 0 ? (
      uploadedFiles.map((file) => (
<label
  key={file}
  style={{
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "13px",
    marginBottom: "6px",
    cursor: "pointer"
  }}
>
  <input
    type="checkbox"
    checked={selectedThemes.includes(file)}
    onChange={() => handleThemeToggle(file)}
  />

  {/* ICON + COLOR + NAME */}
  <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    <img
      src={departmentIcons[file]}
      alt=""
      style={{ width: "16px", height: "16px" }}
    />

    <span
      style={{
        width: "12px",
        height: "12px",
        borderRadius: "50%",
        backgroundColor: schemeClusterColors[file] || "#9e9e9e",
        border: "1px solid #666"
      }}
    />

    <span>
      {formatSchemeName(file)}
    </span>
  </span>
</label>

      ))
    ) : (
      <div style={{ fontSize: "12px", color: "#777" }}>
        No themes found
      </div>
    )}
  </div>
</div>



 
    
      {/* FILE UPLOAD (ONLY FOR ALLOWED USERS) */}

      {canUpload && (
  <div className="upload-box" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
    
{/* Select File (Custom Button) */}
<label
  style={{
    padding: "6px 12px",
    backgroundColor: "#e0e0e0",
    borderRadius: "4px",
    cursor: "pointer",
    border: "1px solid #ccc"
  }}
>
  Choose File
  <input
    type="file"
    accept=".csv"
    onChange={handleFileSelect}
    style={{ display: "none" }}
  />
</label>


    {/* Selected file name */}
    {selectedFile && (
      <span style={{ fontSize: "13px", color: "#333" }}>
        {selectedFile.name}
      </span>
    )}

    {selectedFile && !isUploading && (
  <div style={{ fontSize: "12px", color: "#555" }}>
    File selected. Click <b>Submit</b> to upload and view on map.
  </div>
)}


    {/* Submit button */}
    <button
      onClick={handleSubmitUpload}
      disabled={isUploading}
      style={{
        padding: "6px 12px",
        backgroundColor: "#1976d2",
        color: "white",
        border: "none",
        borderRadius: "4px",
        cursor: isUploading ? "not-allowed" : "pointer"
      }}
    >
      {isUploading ? "Uploading..." : "Submit"}
    </button>
  </div>
)}

 
 
      {/* MAP SECTION */}
<MapContainer

        center={[19.7515, 75.7139]}

        zoom={7.4}

        style={{ height: "100vh", width: "100%" }}
>
<TileLayer
  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
/>

 
        {mahaBorder && <GeoJSON data={mahaBorder} style={{ color: "#333", weight: 1.2 }} />}
 
        {districts && (
<GeoJSON

            data={districts}

            style={() => ({

              color: "#333",

              weight: 1,

              fillColor: getRandomHex(),

              fillOpacity: 0.2,

            })}

            onEachFeature={(feature, layer) => {

              layer.bindPopup("<b>District:</b> " + (feature.properties.DISTRICT || "Unknown"));

            }}

          />

        )}

  {isThemeLoading && (
  <div style={{ fontSize: "12px", color: "#1976d2", marginTop: "4px" }}>
    Updating map layers…
  </div>
)}

 
       {Object.entries(geoLayers).map(([theme, data]) => (
  <MarkerClusterGroup
  key={theme}
  iconCreateFunction={createClusterIcon(theme)}
>

<GeoJSON
  data={data}
  onEachFeature={(feature, layer) =>
    onEachFeature(feature, layer, theme)
  }
  pointToLayer={(feature, latlng) =>
    L.marker(latlng, {
      icon: getCustomIcon(theme)
    })
  }
/>

  </MarkerClusterGroup>
))}
{isThemeLoading && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(255,255,255,0.6)",
      zIndex: 9999,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}
  >
    <div
      style={{
        padding: "12px 20px",
        background: "#1976d2",
        color: "#fff",
        borderRadius: "6px",
        fontSize: "14px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.25)"
      }}
    >
      Updating map layers…
    </div>
  </div>
)}

</MapContainer>
</div>

  );

}
 
export default App;

 